import cn from 'classnames'
import { FC } from 'react'

import { DiamondAnimation, InventoryThing } from '@shared'
import { InventoryCard } from '@store'

import styles from './ItemsRating.module.scss'

type Props = {
  item: InventoryCard
  diff: number
}

export const SlideItem: FC<Props> = ({ item, diff }) => {
  const isAvatar =
    item.displayType && item.displayType.toLowerCase().includes('avatar')

  return (
    <div data-slide-inner className={styles.sliderContent}>
      <div className={styles.sliderContentItem}>
        <div
          data-slide-base-circle
          className={styles.sliderContentItemBaseCircle}
        >
          <div
            style={{
              opacity: diff === 0 ? 1 : 0.2 + (diff * 2.2) / 10,
            }}
            className={styles.sliderContentItemBaseCircleInner}
          />
        </div>
        <div data-slide-current-circle className={styles.currentSlideCircle} />
        {diff === 0 && (
          <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
            <DiamondAnimation optimized />
          </svg>
        )}

        <InventoryThing
          className={cn(styles.thing, {
            [styles.avatarMask]: isAvatar,
          })}
          card={item}
        />
      </div>
    </div>
  )
}
